import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { CartModificationPayload } from '@cart/const';
import { CartDataAccessModule, CompareCartService } from '@cart/data-access';
import { CartFeatureModule } from '@cart/feature';
import { CompareCartComponent } from '@cart/ui';
import { EnvironmentService } from '@core/feature';
import { SdModalService } from '@sdvor/shared/ui/v2';
import { filter } from 'rxjs/operators';

export function compareCartFactory(injector: Injector): () => void {
  return () => {
    const environmentService = injector.get(EnvironmentService);
    if (environmentService.isPlatformBrowser) {
      const compareCartService = injector.get(CompareCartService);
      const newModalService = injector.get(SdModalService);

      compareCartService
        .getDiff()
        .pipe(filter((diff: CartModificationPayload) => diff?.cartModifications && diff?.cartModifications.length > 0))
        .subscribe(() => {
          return newModalService.open(CompareCartComponent, {
            modalType: { xxs: 'fullscreen', lg: 'standard' },
            maxWidth: { lg: '470px' },
          });
        });
    }
  };
}

@NgModule({
  providers: [
    provideAppInitializer(() => {
      const initializerFn = compareCartFactory(inject(Injector));

      return initializerFn();
    }),
  ],
  imports: [CartDataAccessModule, CartFeatureModule],
})
export class CartShellEagerModule {}
